import React, { useEffect, useState } from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import { useTranslation } from 'react-i18next';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../routes/routeName';
import StepperCustom from '../../../components/step/Stepper';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import StateComponents from '../../../components/state-component/StateComponents';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { handleTypingNumber } from '../../../utils/app.utils';
import ContainerButton from '../../../components/button/ContainerButton';
import { alertError, alertSuccess } from '../../../components/alert/swal';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { useDispatch } from 'react-redux';
import { CourseOfStudyApi } from '../../../api/course-of-study/course-of-study.api';
import { NavigateFunction, useLocation, useNavigate, useParams } from 'react-router-dom';
import { timeToView } from '../../../utils/date.utils';
import moment from 'moment';

export default function CourseTuitionFees() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();
    const location = useLocation()
    const { id_course_of_study } = useParams()

    const [tabStep, setTebStep] = useState(0);
    const allStep = [
        {
            name: t('SET_TUITION_FEES_SEMESTER') + " 1",
            isAccept: false,
            icon: null
        },
        {
            name: t('SET_TUITION_FEES_SEMESTER') + " 2",
            isAccept: false,
            icon: null
        },
        {
            name: t('SET_TUITION_FEES_SEMESTER') + " 3",
            isAccept: false,
            icon: null
        },

    ];
    const [tuitionFees, setTuitionFees] = useState<any[]>([
        {
            semester: 1,
            course_tuition_fees_start: "",
            course_tuition_fees_end: "",
            terms: [
                {
                    id_course_tuition_fees: 0,
                    term: 1,
                    price_bath: 0,
                    price_usd: 0,
                },
                {
                    id_course_tuition_fees: 0,
                    term: 2,
                    price_bath: 0,
                    price_usd: 0,
                },
                {
                    id_course_tuition_fees: 0,
                    term: 3,
                    price_bath: 0,
                    price_usd: 0,
                },
                {
                    id_course_tuition_fees: 0,
                    term: 4,
                    price_bath: 0,
                    price_usd: 0,
                },
            ],
        },
        {
            semester: 2,
            course_tuition_fees_start: "",
            course_tuition_fees_end: "",
            terms: [
                {
                    id_course_tuition_fees: 0,
                    term: 1,
                    price_bath: 0,
                    price_usd: 0,
                },
                {
                    id_course_tuition_fees: 0,
                    term: 2,
                    price_bath: 0,
                    price_usd: 0,
                },
                {
                    id_course_tuition_fees: 0,
                    term: 3,
                    price_bath: 0,
                    price_usd: 0,
                },
                {
                    id_course_tuition_fees: 0,
                    term: 4,
                    price_bath: 0,
                    price_usd: 0,
                },
            ],
        },
        {
            semester: 3,
            course_tuition_fees_start: "",
            course_tuition_fees_end: "",
            terms: [
                {
                    id_course_tuition_fees: 0,
                    term: 1,
                    price_bath: 0,
                    price_usd: 0,
                },
                {
                    id_course_tuition_fees: 0,
                    term: 2,
                    price_bath: 0,
                    price_usd: 0,
                },
                {
                    id_course_tuition_fees: 0,
                    term: 3,
                    price_bath: 0,
                    price_usd: 0,
                },
                {
                    id_course_tuition_fees: 0,
                    term: 4,
                    price_bath: 0,
                    price_usd: 0,
                },
            ],
        },
    ]);
    const handleChange = (semesterIndex: number, field: any, value: any) => {
        setTuitionFees((prev) => {
            const newData = [...prev];
            newData[semesterIndex][field] = value;
            return newData;
        });
    };

    const handleChangeTerm = (semesterIndex: number, termIndex: number, field: any, value: any) => {
        setTuitionFees((prev) => {
            const newData = [...prev];
            newData[semesterIndex].terms[termIndex][field] = value;
            return newData;
        });
    };
    const getDetail = async () => {
        await CourseOfStudyApi.getCoursetTuitionFees(id_course_of_study).then((res) => {
            if (res.status < 300) {
                if (res.data?.data?.length > 0) {
                    setTuitionFees(res.data?.data?.map((item: any) => {
                        return {
                            ...item,
                            course_tuition_fees_start_time: item?.course_tuition_fees_start ? timeToView(item?.course_tuition_fees_start): null,
                            course_tuition_fees_end_time:item?.course_tuition_fees_end ? timeToView(item?.course_tuition_fees_end) : null
                        }
                    }))
                }
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    useEffect(() => {
        getDetail()
    }, [])
    const handleSubmit = async () => {
        const body = tuitionFees?.map((item: any) => {
            return {
                ...item,
                course_tuition_fees_start: item?.course_tuition_fees_start ?  item?.course_tuition_fees_start_time ? `${moment(item?.course_tuition_fees_start).format('YYYY-MM-DD')}T${item?.course_tuition_fees_start_time}` : item?.course_tuition_fees_start : '',
                course_tuition_fees_end: item?.course_tuition_fees_end ? item?.course_tuition_fees_end_time ? `${moment(item?.course_tuition_fees_end).format('YYYY-MM-DD')}T${item?.course_tuition_fees_end_time}` : item?.course_tuition_fees_end : ''
            }
        })
        dispatch(setLoading());

        await CourseOfStudyApi.coursetTuitionFees(body, id_course_of_study)
            .then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("SET_TUITION_FEES_SAVE"), t("SET_TUITION_FEES_SAVE_COMPLETED"));
                    navigate(-1)
                    // setDisabled(true)
                }
            })
            .catch((err) => {
                console.log(err);
                alertError(t("SET_TUITION_FEES_SAVE"), t("SET_TUITION_FEES_SAVE_FAILED"));
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    }
    return (
        <div className='w-full'>
            <ContainerLayout
                title={`${location?.state?.degree_name_eng} ${location?.state?.degree_name} / ${location?.state?.faculty_name_eng} ${location?.state?.faculty_name}`}
                hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("SET_TUITION_FEES"),
                                disabled_match: true,
                                pathName: routeName.admission.SetTuitionFees
                            },
                            {
                                key: "complaintSubmit",
                                name: `${t('SET_TUITION_FEES_ACADEMIC_YEAR')} ${location?.state?.academic_year}`,
                                pathName: routeName.admission.SetTuitionFees
                            },
                            {
                                key: "complaintSubmit",
                                name: `${location?.state?.degree_name_eng} ${location?.state?.degree_name} / ${location?.state?.faculty_name_eng} ${location?.state?.faculty_name}`,
                                pathName: ''
                            },
                        ]}
                    />
                }
                content={
                    <div className='w-full'>
                        <section
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                marginTop: "24px",
                            }}
                        >
                            <StepperCustom
                                step={tabStep}
                                setStep={setTebStep}
                                stepLabel={allStep}
                                view={true}
                            />
                        </section>
                        {tuitionFees[tabStep] && (
                            <SemesterComponent
                                data={tuitionFees[tabStep]}
                                semesterIndex={tabStep}
                                onChange={handleChange}
                                onChangeTerm={handleChangeTerm}
                            />
                        )}
                    </div>}
            />
            <ContainerButton
                sxContainer={{ my: 3 }}
                buttonData={[
                    {
                        seq: 1,
                        buttonProps: {
                            onClick: () => { navigate(routeName.admission.SetTuitionFees) },
                        },
                        key: "CANCEL",
                        label: t("SET_TUITION_FEES_RETURN"),
                        type: "CANCEL"
                    },

                    {
                        seq: 2,
                        buttonProps: {
                            onClick: () => {
                                handleSubmit()
                            }
                        },
                        key: "SEND",
                        label: t("SET_TUITION_FEES_CONFIRM"),
                        type: 'SAVE'
                    },

                ]}
            />
        </div>
    )
}

const SemesterComponent = ({ data, semesterIndex, onChange, onChangeTerm }: any) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: '10px' }}>
            <Typography>{t('SET_TUITION_FEES_PAYMENT_PERIOD')}</Typography>
            <StateComponents
                otherProps={{ spacing: 2 }}
                typeProps={[
                    {
                        seq: 1,
                        type: "DATE",
                        gridProps: { xs: 12, md: 3 },
                        fieldProps: {
                            heading: t("SET_TUITION_FEES_PAYMENT_START_DATE"),
                            value: data.course_tuition_fees_start,
                            onChange: (val) => onChange(semesterIndex, "course_tuition_fees_start", val),
                        },
                    },
                    {
                        seq: 2,
                        type: "DATE",
                        gridProps: { xs: 12, md: 3 },
                        fieldProps: {
                            heading: t("SET_TUITION_FEES_PAYMENT_END_DATE"),
                            value: data.course_tuition_fees_end,
                            onChange: (val) => onChange(semesterIndex, "course_tuition_fees_end", val),
                        },
                    },
                    {
                        seq: 3,
                        type: "TEXT_FIELD",
                        gridProps: { xs: 12, md: 3 },
                        fieldProps: {
                            heading: t("SET_TUITION_FEES_PAYMENT_START_TIME"),
                            value: data.course_tuition_fees_start_time || '',
                            onChange: (val) => onChange(semesterIndex, "course_tuition_fees_start_time", val.target.value),
                            type: 'time'
                        }
                    },
                    {
                        seq: 4,
                        type: "TEXT_FIELD",
                        gridProps: { xs: 12, md: 3 },
                        fieldProps: {
                            heading: t("SET_TUITION_FEES_PAYMENT_END_TIME"),
                            value: data.course_tuition_fees_end_time  || '',
                            onChange: (val) => onChange(semesterIndex, "course_tuition_fees_end_time", val.target.value),
                            type: 'time'
                        }
                    },
                ]}
            />

            {data?.terms.map((term: any, index: number) => (
                <Accordion key={index} defaultExpanded
                    sx={{ backgroundColor: "#4A4A4A", color: "white", overflow: 'hidden' }}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                        sx={{ backgroundColor: "#4A4A4A", padding: "10px 16px", fontWeight: "bold", margin: '0px', "& .MuiAccordionSummary-content": { margin: '0px' }, "& .MuiAccordionSummary-content.Mui-expanded": { margin: '0px' } }}>
                        <Typography sx={{ fontWeight: "bold", color: '#fff' }}>{`${t('SET_TUITION_FEES_STUDENT_YEAR')} ${term?.term}`}</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#fff", color: "black", display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', padding: '10px', width: '100%' }} >
                            <StateComponents
                                otherProps={{ spacing: 2 }}
                                sxContainer={{ width: "100%" }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: { xs: 12, md: 6 },
                                        fieldProps: {
                                            heading: t("SET_TUITION_FEES_AMOUNT_THB"),
                                            value: term.price_bath,
                                            onChange: (e) =>
                                                onChangeTerm(semesterIndex, index, "price_bath", e.target.value),
                                        },
                                    },
                                    {
                                        seq: 2,
                                        type: "TEXT_FIELD",
                                        gridProps: { xs: 12, md: 6 },
                                        fieldProps: {
                                            heading: t("SET_TUITION_FEES_AMOUNT_USD"),
                                            value: term.price_usd,
                                            onChange: (e) =>
                                                onChangeTerm(semesterIndex, index, "price_usd", e.target.value),
                                        },
                                    },
                                ]}
                            />
                        </Box>

                    </AccordionDetails>
                </Accordion>
            ))}

        </Box>
    )
}